import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from './components/Layout';
import PageContent from './components/PageContent';
import { API_BASE_URL } from '../config/ApiConfig';

const SummaryCard = ({ title, value, children, bg = 'light', onClick }) => (
  <div className="col-12 col-sm-6 col-lg-3 mb-3">
    <div className="card h-100 shadow-sm" style={{ cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
      <div className="card-body">
        <h6 className="card-title">{title}</h6>
        <div className="d-flex align-items-end justify-content-between">
          <div>
            <h3 className="mb-0">{value}</h3>
            <div className="text-muted small">{children}</div>
          </div>
          <div>
            <div className={`bg-${bg} rounded-circle d-flex align-items-center justify-content-center`} style={{ width:48, height:48 }}>
              <i className="bi bi-bar-chart" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const Home = () => {
  const [arps, setArps] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [arpStatus, setArpStatus] = useState({});
  const [contratoStatus, setContratoStatus] = useState({});
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const ano = localStorage.getItem('anoBase') || new Date().getFullYear().toString();
  const navigate = useNavigate();

  useEffect(() => {
    if (!vinculo || !vinculo.idEntidade) return; // nada a fazer sem vínculo
    setLoading(true);

    const headers = { Authorization: `Bearer ${token}` };

    const reqArps = axios.get(`${API_BASE_URL.ARP}/entidade/${vinculo.idEntidade}/ano/${ano}`, { headers });
    const reqArpStatus = axios.get(`${API_BASE_URL.ARP}/status`, { params: { idEntidade: vinculo.idEntidade, anoBase: ano }, headers });
    const reqContratos = axios.get(`${API_BASE_URL.CONTRATO}/all`, { params: { idEntidade: vinculo.idEntidade, anoBase: ano }, headers });
    const reqContratoStatus = axios.get(`${API_BASE_URL.CONTRATO}/status`, { params: { idEntidade: vinculo.idEntidade, anoBase: ano }, headers });

    Promise.all([reqArps, reqArpStatus, reqContratos, reqContratoStatus])
      .then(([resArps, resArpStatus, resContratos, resContratoStatus]) => {
        setArps(resArps.data || []);
        setArpStatus(resArpStatus.data || {});
        setContratos(resContratos.data || []);
        setContratoStatus(resContratoStatus.data || {});
      })
      .catch(err => {
        console.error('Erro ao carregar dashboard:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  function classifyStatus(status) {
    if (!status) return 'Desconhecido';
    if (status === 'ENCERRADO') return 'Encerrado';
    if (typeof status === 'string' && status.startsWith('VENCE_EM_')) return 'Vencendo';
    return 'Ativo';
  }

  const totals = {
    arps: arps.length,
    arpsAtivos: arps.filter(a => classifyStatus(arpStatus[a.id]) === 'Ativo').length,
    arpsEncerradas: arps.filter(a => classifyStatus(arpStatus[a.id]) === 'Encerrado').length,
    arpsVencendo: arps.filter(a => classifyStatus(arpStatus[a.id]) === 'Vencendo').length,
    contratos: contratos.length,
    contratosAtivos: contratos.filter(c => classifyStatus(contratoStatus[c.id]) === 'Ativo').length,
    contratosEncerrados: contratos.filter(c => classifyStatus(contratoStatus[c.id]) === 'Encerrado').length,
    contratosVencendo: contratos.filter(c => classifyStatus(contratoStatus[c.id]) === 'Vencendo').length,
  };

  return (
    <Layout>
      <PageContent>
        {loading ? (
          <div className="text-center my-5">Carregando dashboard...</div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <SummaryCard title="ARPs (total)" value={totals.arps} bg="primary" onClick={() => navigate('/arps')} />
              <SummaryCard title="ARPs ativos" value={totals.arpsAtivos} bg="success" onClick={() => navigate('/arps?status=' + encodeURIComponent('ATIVO'))} />
              <SummaryCard title="ARPs vencendo" value={totals.arpsVencendo} bg="warning" onClick={() => navigate('/arps?status=' + encodeURIComponent('VENCE'))} />
              <SummaryCard title="ARPs encerradas" value={totals.arpsEncerradas} bg="danger" onClick={() => navigate('/arps?status=' + encodeURIComponent('ENCERRADO'))} />

              <SummaryCard title="Contratos (total)" value={totals.contratos} bg="info" onClick={() => navigate('/contratos') } />
              <SummaryCard title="Contratos ativos" value={totals.contratosAtivos} bg="success" onClick={() => navigate('/contratos?status=' + encodeURIComponent('ATIVO'))} />
              <SummaryCard title="Contratos vencendo" value={totals.contratosVencendo} bg="warning" onClick={() => navigate('/contratos?status=' + encodeURIComponent('VENCE'))} />
              <SummaryCard title="Contratos encerrados" value={totals.contratosEncerrados} bg="danger" onClick={() => navigate('/contratos?status=' + encodeURIComponent('ENCERRADO'))} />
            </div>
          </div>
        )}
      </PageContent>
    </Layout>
  );
};

export default Home;
